<template>
  <section class="recommended-posts" v-if="posts.length">
    <h2>Recommended Reading</h2>
    <div class="recommended-grid">
      <a v-for="post in posts" :key="post.url" :href="post.url" class="recommended-card">
        <div class="recommended-image">
          <img :src="post.poster" :alt="post.title" loading="lazy">
        </div>
        <div class="recommended-content">
          <span class="recommended-date">{{ post.date }}</span>
          <h3>{{ post.title }}</h3>
          <p>{{ post.desc }}</p>
          <span class="recommended-link">Read More</span>
        </div>
      </a>
    </div>
  </section>
</template>

<script>
import doc from '@/documents/blogs.js';

export default {
  name: 'RecommendedPosts',
  props: {
    currentUrl: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 3
    }
  },
  computed: {
    posts() {
      return doc.bloglist.en
        .filter((post) => post.url !== this.currentUrl)
        .slice()
        .reverse()
        .slice(0, this.limit);
    }
  }
};
</script>

<style scoped>
.recommended-posts {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 1px solid #e5e7eb;
}

.recommended-posts h2 {
  margin: 0 0 22px;
  color: #1f2937;
  font-size: 28px;
  line-height: 1.25;
}

.recommended-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.recommended-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: inherit;
  text-decoration: none;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.recommended-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.14);
}

.recommended-image {
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #f3f4f6;
}

.recommended-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.recommended-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px;
}

.recommended-date {
  color: #6b7280;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 8px;
}

.recommended-content h3 {
  color: #111827;
  font-size: 18px;
  line-height: 1.35;
  margin: 0 0 10px;
}

.recommended-content p {
  color: #4b5563;
  display: -webkit-box;
  font-size: 14px;
  line-height: 1.55;
  margin: 0 0 16px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.recommended-link {
  color: #128c4f;
  font-size: 14px;
  font-weight: 700;
  margin-top: auto;
}

@media (max-width: 768px) {
  .recommended-posts {
    margin-top: 36px;
    padding-top: 26px;
  }

  .recommended-posts h2 {
    font-size: 24px;
  }

  .recommended-grid {
    grid-template-columns: 1fr;
  }
}
</style>
